var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('ToolBar',{attrs:{"dicts":_vm.dicts},on:{"on-change":_vm.dealWithToolBarChange}}),_c('CustomTable',{attrs:{"dicts":_vm.dicts,"queryParams":_vm.queryParams}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }